import { combineReducers } from "redux";
import dashboardReducer from "./dashboardReducer";
import worklistReducer from "./worklistReducer";
import parkedReducer from "./parkedReducer";
import submittedForVerificationReducer from './submittedForVerificationReducer';
import submittedToTypistReducer from "./submittedToTypistReducer";
import lockedReducer from "./lockedReducer";
import reportViewerReducer from "./reportViewerReducer";

const groupAdminReducer = combineReducers({
    dashboard: dashboardReducer,
    worklist: worklistReducer,
    parked: parkedReducer,
    submittedForVerification: submittedForVerificationReducer,
    submittedToTypist: submittedToTypistReducer,
    locked: lockedReducer,
    reportViewer: reportViewerReducer
});

export default groupAdminReducer;
